export const defaultFormValues = {
  name: "",
  target: undefined,
  region: undefined,
  category: "prod",
};

export const CARD_MAX_TARGET_VALUE = 4294967295;
